<app-profile-user [user]="user" [menuIsOpened]="menuIsOpened"></app-profile-user>
<app-profile-language [menuIsOpened]="menuIsOpened" [ngClass]="{'menu-opened': menuIsOpened}"></app-profile-language>
